import axiosInstance from "../plugins/axios-plugin";

export default {
  namespaced: true,
  state: {
    pageTitle: null,
    breadcrumbs: [],
    hasContentFooter: false,
    activeRoute: null,
    confirmDialogSetting: {
      show: false,
      title: null,
      message: null,
      cancelButtonLabel: null,
      confirmButtonLabel: null,
      cancelHandler: null,
      confirmHandler: null
    },
    loading: {
      show: false,
      message: null
    },
    cardToDuplicate: null,
    resourceEditor: {
      locked: false,
      forceOverride: false,
      path: null,
      data: null
    }
  },
  getters: {
    pageTitle: state => state.pageTitle,
    breadcrumbs: state => state.breadcrumbs,
    hasContentFooter: state => state.hasContentFooter,
    activeRoute: state => state.activeRoute,
    showConfirmDialog: state => state.confirmDialogSetting.show,
    confirmDialogSetting: state => state.confirmDialogSetting,
    showLoading: state => state.loading.show,
    loadingMessage: state => state.loading.message,
    cardToDuplicate: state => state.cardToDuplicate,
    resourceEditorIsLocked: state => state.resourceEditor.locked,
    resourceEditorForceOverride: state => state.resourceEditor.forceOverride,
    resourceEditorPath: state => state.resourceEditor.path,
    resourceEditorData: state => state.resourceEditor.data
  },
  actions: {
    setPageTitle: ({ commit }, payload) => {
      commit('setPageTitle', payload)
    },
    setBreadcrumbs: ({ commit }, payload) => {
      commit('setBreadcrumbs', payload)
    },
    toggleContentFooter: ({ commit }, payload) => {
      commit('toggleContentFooter', payload)
    },
    setActiveRoute: ({ commit }, payload) => {
      commit('setActiveRoute', payload)
    },
    showConfirmDialog: ({ commit }, payload) => {
      payload.show = true
      commit('setConfirmDialogSetting', payload)
    },
    hideConfirmDialog ({ commit }) {
      commit('setConfirmDialogSetting', {
        show: false,
        title: null,
        message: null,
        cancelButtonLabel: null,
        confirmButtonLabel: null,
        cancelHandler: null,
        confirmHandler: null
      })
    },
    showLoading ({ commit }, message) {
      commit('setLoading', {
        show: true,
        message: message || null
      })
    },
    hideLoading ({ commit }) {
      commit('setLoading', {
        show: false,
        message: null
      })
    },
    duplicateCard ({ commit }, payload) {
      commit('setCardToDuplicate', payload)
    },

    registerResourceEditor: async ({ commit }, payload) => {
      try {
        await axiosInstance.post('/editors', {
          path: payload.path
        })
      } catch (error) {
        console.log(error)
      }
    },

    removeResourceEditor: async ({getters}, payload) => {
      try {
        await axiosInstance.delete('/editors', {
          params: {
            path: payload.path
          }
        })
      } catch (error) {
        console.log(error)
      }
    },

    leaveResource: async ({ commit, dispatch, getters }, payload) => {
      if (!getters.resourceEditorForceOverride) {
        await dispatch('removeResourceEditor', payload)
      }

      commit('setResourceEditorLocked', false)
      commit('setResourceEditorOverride', false)
      commit('setResourceEditorData', null)
      commit('setResourceEditorPath', null)
    },

    forceResourceOverride: async ({ dispatch, commit, getters }) => {
      await dispatch('removeResourceEditor', { path: getters.resourceEditorPath })
      await dispatch('registerResourceEditor', { path: getters.resourceEditorPath })
      commit('setResourceEditorLocked', false)
      commit('setResourceEditorOverride', true)
      commit('setResourceEditorData', null)
      commit('setResourceEditorPath', null)
    }
  },
  mutations: {
    setPageTitle: (state, payload) => {
      state.pageTitle = payload
    },
    setBreadcrumbs: (state, payload) => {
      state.breadcrumbs = payload
    },
    toggleContentFooter: (state, payload) => {
      state.hasContentFooter = payload
    },
    setActiveRoute: (state, payload) => {
      state.activeRoute = payload
    },
    setConfirmDialogSetting: (state, payload) => {
      state.confirmDialogSetting = payload
    },
    setLoading: (state, payload) => {
      state.loading = payload
    },
    setCardToDuplicate: (state, payload) => {
      state.cardToDuplicate = payload
    },
    setResourceEditorLocked: (state, payload) => {
      state.resourceEditor.locked = payload
    },
    setResourceEditorOverride: (state, payload) => {
      state.resourceEditor.forceOverride = payload
    },
    setResourceEditorPath: (state, payload) => {
      state.resourceEditor.path = payload
    },
    setResourceEditorData: (state, payload) => {
      state.resourceEditor.data = payload
    }
  }
}
